import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StreetAddressField = () => {
    const value = useBrokerDetailsStore((s) => s.businessAddress.street1);
    const updateBusinessAddress = useBrokerDetailsStore((s) => s.updateBusinessAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessStreet1);
    
    return (
        <>
            <TextBox
                id='cAddress1'
                value={value}
                onChange={(v) => updateBusinessAddress({ street1: v })}
                width={'100%'}
                label='Street Address'
                required={isBroker}
                placeholder='Street number and name'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon icon={'asterisk'} className='required-icon' />
            </ShowIf>
        </>
    );
};

